<template>
    <div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Feedback Questionare</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br />
            <v-row dense justify="center">
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded color="#0F2027" :items="academic_year_list" label="Academic Year" item-text="ay" item-value="id" outlined dense v-model="academicyear"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded color="#0F2027" :items="feedback_type_list" label="Feedback Type" item-text="feedbacktype" item-value="ft_id" outlined dense v-model="feedbacktype"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        rounded
                        color="#0F2027"
                        :items="feedback_question_type_list"
                        label="Feedback Question Type"
                        item-text="feedbackquestiontype"
                        item-value="qt_id"
                        outlined
                        dense
                        v-model="feedbackquestiontype"
                    ></v-autocomplete>
                </v-col>
                <!-- <v-col cols="12" sm="3" md="3">
                    <v-btn class="mt-6 button">Fetch</v-btn>
                </v-col> -->
            </v-row>
            <v-row dense justify="center">
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" :disabled="academicyear == null || feedbacktype == null || feedbackquestiontype == null" @click="AddQuestions()">Add Questions</v-btn>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-btn class="button" :disabled="academicyear == null || feedbacktype == null || feedbackquestiontype == null" @click="viewQuestions()">View Questions</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <span v-if="show_card">
            <v-card class="box" v-if="viewQueFlag">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>View Feedback Questionare</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
                <v-col cols="12" sm="12" md="12">
                    <v-simple-table dense class="elevation-1 mytable">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                <th>Feedback Type</th>
                                <th>Question Type</th>
                                <th>Question No.</th>
                                <th>Question Statement</th>
                                <th>Weightage</th>
                                <th>Options</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="q in feedback_questionare_list" :key="q.id">
                                <td>{{q.srno}}</td>
                                <td>{{q.feedbacktype}}</td>
                                <td>{{q.feedbackquestiontype}}</td>
                                <td>{{q.qno}}</td>
                                <td>
                                    <span v-if="q.question_statement" v-html="q.question_statement">
                                        {{ q.question_statement }}
                                    </span>
                                </td>
                                <td>
                                    {{q.weightage}}
                                </td>
                                <td>
                                    {{q.option_size}}
                                </td>
                                <td>
                                    <span>
                                        <v-btn color="#0F2027" fab x-small outlined icon @click="editItem(q)">
                                            <v-avatar style="" class="edit-avatar">
                                                <v-icon color="#0F2027" class="edit-v-icon">edit</v-icon>
                                            </v-avatar>
                                        </v-btn>
                                    </span>
                                </td>
                                <td>
                                    <span>
                                        <v-btn color="error" fab x-small outlined icon @click="deleteitem(q.id)">
                                            <v-avatar style="" class="delete-avatar">
                                                <v-icon color="erro" class="delete-v-icon">delete</v-icon>
                                            </v-avatar>
                                        </v-btn>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-card>
            <v-card class="box" v-else>
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>Add Feedback Questionare</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <br />
                <v-row dense justify="center"><strong>Question No. {{questionNo}}</strong></v-row>
                <v-card class="box">
                    <v-row justify="center">
                        <v-col cols="12" sm="3">
                            <v-text-field color="#0F2027" label="Marks" v-model.trim="weightage" type="number" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-checkbox color="#0F2027" v-model="isactive" class="mx-2" label="Is Actice"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="7" md="7">
                            <ckeditor v-model="question" :config="editorConfig"></ckeditor>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card class="box">
                    <v-row justify="center">
                        <v-col cols="12" sm="3">
                            <v-text-field color="#0F2027" label="Marks" v-model.trim="option_01_weightage" type="number" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-checkbox color="#0F2027" v-model="option_01_isactive" class="mx-2" label="Is Actice"></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="2" md="2">
                            Option 1
                        </v-col>
                        <v-col cols="12" sm="7" md="7">
                            <ckeditor v-model="option_01" :config="editorConfig"></ckeditor>
                        </v-col>
                    </v-row>
                </v-card>
                <v-card class="box">
                    <v-row justify="center">
                        <v-col cols="12" sm="3">
                            <v-text-field color="#0F2027" label="Marks" v-model.trim="option_02_weightage" type="number" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-checkbox color="#0F2027" v-model="option_02_isactive" class="mx-2" label="Is Actice"></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="2" md="2">
                            Option 2
                        </v-col>
                        <v-col cols="12" sm="7" md="7">
                            <ckeditor v-model="option_02" :config="editorConfig"></ckeditor>
                        </v-col>
                        <v-col cols="12" sm="3" md="3"> </v-col>
                    </v-row>
                </v-card>
                <v-form id="profile_form" @submit.prevent="submit">
                    <v-card class="box" v-for="(input, index) in inputs" in :key="index">
                        <v-col cols="12" sm="12">
                            <v-row justify="center">
                                <v-col cols="12" sm="3">
                                    <v-text-field color="#0F2027" label="Marks" v-model.trim="input.weightage" type="number" required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-checkbox color="#0F2027" v-model="input.isactive" class="mx-2" label="Is Actice"></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="2" md="2">
                                    Option {{index+3}}<br />
                                    <v-btn color="red" fab small dark @click="deleteRow(index)" class="del">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" sm="7" md="7">
                                    <ckeditor v-model="input.text" :config="editorConfig"></ckeditor>
                                </v-col>
                                <v-col cols="12" sm="3" md="3"> </v-col>
                            </v-row>
                        </v-col>
                    </v-card>
                    <div v-show="optionsize <=3">
                        <v-btn class="button" @click="addRow">
                            Add Option
                        </v-btn>
                    </div>
                </v-form>
                <v-row justify="center">
                    <v-btn class="button" @click="savemcq">Save</v-btn>
                </v-row>
            </v-card>
        </span>
        <span v-if="question_info != null">
            <v-dialog v-model="dialog_edit" persistent fullscreen>
                <v-card>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Edit Question
                            </strong>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn rounded small @click="dialog_edit = false">Close</v-btn>
                    </v-toolbar>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-row justify="center">
                                <v-col cols="12" sm="3">
                                    <v-text-field color="#0F2027" label="Marks" v-model.trim="question_info.weightage" type="number" required></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-checkbox color="#0F2027" v-model="question_info.isactive" class="mx-2" label="Is Active"></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="7" md="7">
                                    <ckeditor v-model="question_info.question_statement" :config="editorConfig"></ckeditor>
                                </v-col>
                            </v-row>
                        </v-card>
                        <span v-for="(opt,index) in question_info.option_list" :key="opt.opt_id">
                            <v-card class="box">
                                <v-row justify="center">
                                    <v-col cols="12" sm="3">
                                        <v-text-field color="#0F2027" label="Marks" v-model.trim="opt.weightage" type="number" required></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-checkbox color="#0F2027" v-model="opt.isactive" class="mx-2" label="Is Actice"></v-checkbox>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="2" md="2">
                                        Option {{index+1}}
                                        <v-btn color="red" fab small dark @click="deleteOption(opt.opt_id,opt)" class="del">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                    </v-col>
                                    <v-col cols="12" sm="7" md="7">
                                        <ckeditor v-model="opt.option_statement" :config="editorConfig"></ckeditor>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </span>
                        <v-form id="profile_form" @submit.prevent="submit">
                            <v-card class="box" v-for="(input, index) in inputs" in :key="index">
                                <v-col cols="12" sm="12">
                                    <v-row justify="center">
                                        <v-col cols="12" sm="3">
                                            <v-text-field color="#0F2027" label="Marks" v-model.trim="input.weightage" type="number" required></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-checkbox color="#0F2027" v-model="input.isactive" class="mx-2" label="Is Actice"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="2" md="2">
                                            Option {{sise_opt + index}}<br />
                                            <v-btn color="red" fab small dark @click="deleteRow(index)" class="del">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="12" sm="7" md="7">
                                            <ckeditor v-model="input.text" :config="editorConfig"></ckeditor>
                                        </v-col>
                                        <v-col cols="12" sm="3" md="3"> </v-col>
                                    </v-row>
                                </v-col>
                            </v-card>
                        </v-form>
                        <div v-show="optionsize <=2">
                            <v-btn class="button" @click="addRow">
                                Add Option
                            </v-btn>
                        </div>
                    </v-col>
                    <v-row dense justify="center">
                        <v-btn class="button" @click="saveEditedQuestion(question_info)">Update</v-btn>
                        <v-btn class="button" @click="dialog_edit = false">Cancel</v-btn>
                    </v-row>
                </v-card>
            </v-dialog>
        </span>
    </div>
</template>
<script>
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data: () => ({
            editorConfig: {
                height: "100px",
                extraPlugins: "mathjax",
                mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
            },
            overlay: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            academic_year_list: [],
            feedback_type_list: [],
            feedback_question_type_list: [],
            feedback_questionare_list: [],
            academicyear: null,
            feedbacktype: null,
            feedbackquestiontype: null,
            viewQueFlag: false,
            //Question Data
            question: "",
            weightage: null,
            isactive: true,
            option_01: null,
            option_01_isactive: true,
            option_01_weightage: null,
            option_02: null,
            option_02_weightage: null,
            option_02_isactive: true,
            iscorrect_01: null,
            iscorrect_02: null,
            inputs: [],
            optionsize: 0,
            option_statement: null,
            show_card: false,
            questionNo: null,
            dialog_edit: false,
            question_info: null,
            sise_opt: "",
        }),
        watch: {
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            this.onload();
        },
        methods: {
            savemcq() {
                var form = document.getElementById("profile_form");
                let formData = new FormData(form);
                for (let i = 0; i < this.inputs.length; i++) {
                    formData.append("opt_id", i);
                    formData.append("opttext", this.inputs[i].text);
                    formData.append("optweightage", this.inputs[i].weightage);
                    formData.append("optisactive", this.inputs[i].isactive);
                    if (this.inputs[i].text == "") {
                        this.showSnackbar("#b71c1c", "Please enter option"); // show snackbar
                        return;
                    }
                }
                formData.append("weightage", this.weightage);
                formData.append("question", this.question);
                formData.append("option_01", this.option_01);
                formData.append("option_01_weightage", this.option_01_weightage);
                formData.append("option_01_isactive", this.option_01_isactive);
                formData.append("option_02", this.option_02);
                formData.append("option_02_weightage", this.option_02_weightage);
                formData.append("option_02_isactive", this.option_02_isactive);
                formData.append("isactive", this.isactive);
                formData.append("questionNo", this.questionNo);
                formData.append("academicyear", this.academicyear);
                formData.append("feedbacktype", this.feedbacktype);
                formData.append("feedbackquestiontype", this.feedbackquestiontype);
                if (this.question == "" || this.question == null) {
                    this.showSnackbar("#b71c1c", "Please enter question !!!"); // show snackbar
                    return;
                }
                if (this.option_01 == "" || this.option_01 == null) {
                    this.showSnackbar("#b71c1c", "Please Select Option 01 !!!"); // show snackbar
                    return;
                }
                if (this.option_02 == "" || this.option_02 == null) {
                    this.showSnackbar("#b71c1c", "Please Select Option 02 !!!");
                    return;
                }
                this.overlay = true;
                axios
                    .post("/Feedback/saveFeedbackQuestion", formData, {})
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", res.data.status_reason);
                            this.AddQuestions();
                            this.reset();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            saveEditedQuestion(que) {
                var form = document.getElementById("profile_form");
                let formData = new FormData(form);
                for (let i = 0; i < this.inputs.length; i++) {
                    formData.append("opt_id", i);
                    formData.append("opttext", this.inputs[i].text);
                    formData.append("optweightage", this.inputs[i].weightage);
                    formData.append("optisactive", this.inputs[i].isactive);
                    if (this.inputs[i].text == "") {
                        this.showSnackbar("#b71c1c", "Please enter option"); // show snackbar
                        return;
                    }
                }
                formData.append("que_id", que.id);
                formData.append("weightage", que.weightage);
                formData.append("isactive", que.isactive);
                formData.append("question", que.question_statement);
                for (let i = 0; i < que.option_list.length; i++) {
                    formData.append("opt_id", que.option_list[i].opt_id);
                    formData.append("opttext", que.option_list[i].option_statement);
                    formData.append("optweightage", que.option_list[i].weightage);
                    formData.append("optisactive", que.option_list[i].isactive);
                }
                // formData.append("options", que.option_list);

                this.overlay = true;
                axios
                    .post("/Feedback/saveEditedFeedbackQuestion", formData, {})
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", res.data.status_reason);
                            this.dialog_edit = false;
                            this.viewQuestions();
                            this.reset();
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            reset() {
                (this.question = ""),
                    (this.weightage = null),
                    (this.isactive = true),
                    (this.option_01 = null),
                    (this.option_01_isactive = true),
                    (this.option_01_weightage = null),
                    (this.option_02 = null),
                    (this.option_02_weightage = null),
                    (this.option_02_isactive = true),
                    (this.iscorrect_01 = null),
                    (this.iscorrect_02 = null),
                    (this.inputs = []),
                    (this.optionsize = 0),
                    (this.option_statement = null);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                this.overlay = true;
                axios
                    .post("/Feedback/getFeedbackQuestionare")
                    .then((res) => {
                        this.academic_year_list = res.data.academic_year_list;
                        this.feedback_type_list = res.data.feedback_type_list;
                        this.feedback_question_type_list = res.data.feedback_question_type_list;
                        // this.sel_ay_data = res.data.curr_ay;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            AddQuestions() {
                this.show_card = true;
                this.viewQueFlag = false;
                if (this.academicyear == null || this.feedbacktype == null || this.feedbackquestiontype == null) {
                    this.showSnackbar("#b71c1c", "Please select required fields!");
                    return;
                }
                this.overlay = true;
                const data = {
                    academicyear: this.academicyear,
                    feedbacktype: this.feedbacktype,
                    feedbackquestiontype: this.feedbackquestiontype,
                    type: "Add",
                };
                axios
                    .post("/Feedback/viewFeedbackQuestionare", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.questionNo = res.data.questionNo;
                            // alert("questionNo"+this.questionNo)
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            viewQuestions() {
                this.show_card = true;
                if (this.academicyear == null || this.feedbacktype == null || this.feedbackquestiontype == null) {
                    this.showSnackbar("#b71c1c", "Please select required fields!");
                    return;
                }
                this.overlay = true;
                this.viewQueFlag = true;
                const data = {
                    academicyear: this.academicyear,
                    feedbacktype: this.feedbacktype,
                    feedbackquestiontype: this.feedbackquestiontype,
                    type: "View",
                };
                axios
                    .post("/Feedback/viewFeedbackQuestionare", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.feedback_questionare_list = res.data.feedback_questionare_list;
                            if (this.feedback_questionare_list.length == 0) {
                                this.showSnackbar("#b71c1c", "Questions not added yet! Please add questions.");
                            }
                        } else {
                            this.showSnackbar("#b71c1c", "Questions not added yet! Please add questions.");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            radio(index) {
                // alert(index)
                if (index == "b" || index == "a") {
                    // alert("in if")
                    for (let i = 0; i < this.inputs.length; i++) {
                        this.inputs[i].value = false;
                    }
                } else {
                    // alert("in else")
                    this.iscorrect_01 = false;
                    for (let i = 0; i < this.inputs.length; i++) {
                        if (i == index) {
                            if (this.inputs[i].inputs == false) {
                                this.inputs[i].value = true;
                            }
                        } else {
                            this.inputs[i].value = false;
                            this.iscorrect_01 = false;
                        }
                    }
                }
            },
            editItem(question_edit) {
                // alert(question_edit);
                this.dialog_edit = true;
                this.question_info = question_edit;
                this.sise_opt = this.question_info.option_list.length + 1;
            },
            deleteitem(delete_que) {
                const change = confirm("Are you sure you want to delete question!");
                if (change) {
                    this.overlay = true;
                    const data = {
                        que_id: delete_que,
                    };
                    axios
                        .post("/Feedback/deleteFeedbackQuestionare", data)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4caf50", res.data.status_reason);
                                this.viewQuestions();
                            } else {
                                this.showSnackbar("#b71c1c", res.data.status_reason);
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        })
                        .finally(() => {
                            this.overlay = false;
                        });
                }
            },
            deleteOption(opt_id,opt){
                const change = confirm("Are you sure you want to delete question!");
                if (change) {
                    this.overlay = true;
                    const data = {
                        opt_id: opt_id,
                    };
                    axios
                        .post("/Feedback/deleteFeedbackQuestionareOption", data)
                        .then((res) => {
                            if (res.data.flag == "YES") {
                                this.showSnackbar("#4caf50", res.data.status_reason);
                               this.question_info.option_list.splice(this.question_info.option_list.indexOf(opt),1)
                                this.viewQuestions();
                            } else {
                                this.showSnackbar("#b71c1c", res.data.status_reason);
                            }
                        })
                        .catch((error) => {
                            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        })
                        .finally(() => {
                            this.overlay = false;
                        });
                }
            },
            deleteRow(index) {
                this.inputs.splice(index, 1);
                this.optionsize--;
            },
            addRow() {
                this.inputs.push({
                    value: "",
                    text: "",
                    weightage: null,
                    isactive: true,
                });
                this.optionsize++;
            },
        },
    };
</script>
<style scoped>
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
    .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }
    .radiospace {
        margin: 0.5rem !important;
        padding: 0%;
    }
</style>
